'use strict';

import angular from 'angular';

class MePersonalCtrl {
  constructor(ToastrSvc, UserSvc) {
    var that = this;
    this.personalFields = [
      {display: 'Prefix', attribute: 'prefix'},
      {display: 'First Name', attribute: 'fname'},
      {display: 'Preferred Name', attribute: 'preferredName'},
      {display: 'Middle Name', attribute: 'mname'},
      {display: 'Last Name', attribute: 'lname'},
      {display: 'Suffix', attribute: 'suffix'},
      {display: 'Gender', attribute: 'gender'},
      {display: 'Birth Day', attributes: [
        {attribute: 'birthmonth', map: 'displayMonth'},
        {attribute: 'birthday'}
      ]},
      {display: 'Birth Year', attribute: 'birthyear'}
    ];
    // display mappings
    this.maps = {displayMonth: {
      0: 'January', 1: 'February', 2: 'March', 3: 'April',
      4: 'May', 5: 'June', 6: 'July', 7: 'August',
      8: 'September', 9: 'October', 10: 'November', 11: 'December'
    }};

    this.model = {};
    this.edit = function(user) {
      that.user = user; // set user
      that.model = angular.copy(user);
      if(typeof that.model.birthmonth === 'number') {
        that.model.birthmonth = that.model.birthmonth.toString();
      }
      that.showForm = true;
    };

    this.view = function() {
      // refresh form model
      if(that.user) { that.model = angular.copy(that.user); }
      that.showForm = false;
    };

    this.cancel = this.view;

    // this.model set in parent UserCtrl
    this.submit = function(errorCb) {
      var user = that.model;
      if(typeof user.birthmonth === 'string') {
        user.birthmonth = Number(user.birthmonth);
      }
      UserSvc.updateMe(user).$promise
        .then(function(res) {
          angular.extend(that.user, res.toJSON());
          that.showForm = false;
          ToastrSvc.success('User Personal Information Updated');
        })
        .catch(errorCb);
    };
  }
}

MePersonalCtrl.$inject = ['ToastrSvc', 'UserSvc'];

export default ['ToastrSvc', 'UserSvc', MePersonalCtrl];
